interface Props {
  activeColor: string;
}
const AudioWaveIcon = (props: Props) => {
  const activeColor = props.activeColor ? props.activeColor : "#0f1560";
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="8" y="20" width="5" height="8" rx="2.5" fill="#234cfc" />

      <rect x="16" y="16" width="5" height="16" rx="2.5" fill="#234cfc" />

      <rect x="24" y="10" width="5" height="28" rx="2.5" fill="#234cfc" />

      <rect x="32" y="16" width="5" height="16" rx="2.5" fill="#234cfc" />

      <rect x="40" y="20" width="5" height="8" rx="2.5" fill="#234cfc" />
    </svg>
  );
};

export default AudioWaveIcon;
